import { useEffect, useRef } from 'react';

import styles from './index.module.scss';

const useOnClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

const Modal = ({
  showCloseIcon = true,
  open,
  onClose,
  dataTestid = 'modal',
  children
}) => {
  const ref = useRef();
  useOnClickOutside(ref, () => onClose());

  if (!open) return null;

  return (
    <section className={styles.wrapper} data-testid={dataTestid}>
      <div className={styles.modal} ref={ref}>
        {showCloseIcon && (
          <button
            data-testid={`${dataTestid}-button`}
            className={styles.close}
            onClick={() => onClose()}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.0013 0.444013L0.445665 1.99965L7.44604 9.00002L0.445686 16.0004L2.00132 17.556L9.00167 10.5557L16.002 17.556L17.5576 16.0004L10.5573 9.00002L17.5577 1.99966L16.002 0.444025L9.00167 7.44439L2.0013 0.444013Z"
                fill="black"
              />
            </svg>
          </button>
        )}

        {children}
      </div>
    </section>
  );
};

export default Modal;
